export const DEFAULT_MULTIPLIERS = {
  1: 1.0,
  2: 0.7,
  3: 0.4,
  4: 0.2,
};

export { WORLD_BANK_TIERS } from './countries';
